import { Component, Input } from '@angular/core';
import type { InnogyComponentRendering } from '@core/jss-models';
import { getFieldValue } from '@core/jss-utils';
import {
  hasSelectedProductFormControlId,
  type OrderCrossSellFormValues,
} from '@innogy/become-a-customer/state';
import type { StoreProductData } from '@legacy/common-ui-models';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Store } from '@ngrx/store';
import { SetValueAction, type FormGroupState } from 'ngrx-forms';
import type { Observable } from 'rxjs';

@Component({
  selector: 'wl-cross-sell-product-info-modal',
  templateUrl: './cross-sell-product-info-modal.component.html',
})
export class CrossSellProductInfoModalComponent {
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input({ required: true }) rendering!: InnogyComponentRendering;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input({ required: true }) product!: StoreProductData;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input({ required: true }) formState!: Observable<
    FormGroupState<OrderCrossSellFormValues>
  >;

  constructor(
    private readonly store: Store,
    private readonly activeModal: NgbActiveModal
  ) {}

  public closeModal() {
    this.activeModal.close();
  }

  public selectProduct() {
    this.store.dispatch(
      new SetValueAction(hasSelectedProductFormControlId, true)
    );
    this.closeModal();
  }

  public rejectProduct() {
    this.store.dispatch(
      new SetValueAction(hasSelectedProductFormControlId, false)
    );
    this.closeModal();
  }

  get usps() {
    return this.product.content.usps ?? [];
  }

  get labels() {
    return {
      perMonthLong: getFieldValue(this.rendering, 'CrossSellMonthlyLong', ''),
      addProduct: getFieldValue(this.rendering, 'CrossSellAddLabel', ''),
      rejectProduct: getFieldValue(this.rendering, 'CrossSellRejectLabel', ''),
    };
  }
}
